import ar from './ar.json';
import en from './en.json';

/** Registered from `app.config.tsx` under the `members` namespace (W2). */
export const membersCatalogs = { ar, en };
